import { createFileRoute } from '@tanstack/react-router'

import { ResearchBarFormShell } from '@/components/research-bar/research-bar-form-shell'

export const Route = createFileRoute('/recherche/integration')({
  component: ResearchBarEmbedComponent,
})

export function ResearchBarEmbedComponent() {
  return (
    <div className="flex min-h-screen min-w-screen items-stretch justify-center p-2 md:p-4">
      <ResearchBarFormShell className="w-full items-stretch p-3 shadow-none md:p-4" />
    </div>
  )
}
